import { OnSchedRest } from '../../../OnSchedRest'
import { OnSchedTemplates } from '../../../OnSchedTemplates';

export const InitLocationDomElements = (element) => {
  // move some code from the InitWizardDomElements

      // Business Hours and Timezone dropdown options
    //   var elBusinessTimezone = document.querySelector(".onsched-wizard.onsched-form select[name=timezoneName]");
    //   var elBusinessHoursTz = document.querySelector("h4.onsched-business-hours-tz");
    //   elBusinessHoursTz.innerHTML = elBusinessTimezone.options[elBusinessTimezone.selectedIndex].text;;
    //   elBusinessTimezone.addEventListener("change", function(event) {
    //       var elBusinessTimezone = document.querySelector(".onsched-wizard.onsched-form select[name=timezoneName]");
    //       var elBusinessHoursTz = document.querySelector("h4.onsched-business-hours-tz");
    //       elBusinessHoursTz.innerHTML = elBusinessTimezone.options[elBusinessTimezone.selectedIndex].text;;

    //   }, false);

      // Call the endpoint to receive all system states
      // and use data to populate the states options and country options
}
